import {
  ID,
  ResponseFill,
  HttpIgnore, IResource,
} from 'simpli-web-sdk'
import Motorista from '@/model/resource/Motorista'
import * as Helper from '@/helpers'
import DateFilterRequest from '@/model/request/DateFilterRequest'
import {ItrackCollection} from '@/helpers'
import {UF} from '@/enums/UF'
import {Region} from '@/enums/Region'
import {DeliverySlaStatus} from '@/enums/DeliverySlaStatus'
import {TipoSistema} from '@/enums/TipoSistema'

@HttpIgnore()
export default class DeliveryDriverRequest extends DateFilterRequest {
  readonly $name: string = 'DeliveryDriverRequest'

  allSistema = ItrackCollection.allSistema
  allCentroDeCusto = ItrackCollection.allCentroDeCusto.prependNull('app.all')
  allTipoInsumo = ItrackCollection.allTipoInsumo.prependNull('app.all')
  allSlaStatus = ItrackCollection.allSlaStatus.prependNull('app.all')

  get ufCollection() {
    return ItrackCollection.getUfCollection(this.region).prependNull('app.all')
  }

  get regionCollection() {
    return ItrackCollection.allRegion.prependNull('app.all')
  }

  get auditCollection() {
    return ItrackCollection.allAudit.prependNull('app.all')
  }

  idFilial = Helper.getIdFilial()

  motorista = new Motorista()

  @ResponseFill()
  idMotorista: ID | null = null

  @ResponseFill()
  uf: UF | null = null

  @ResponseFill()
  region: Region | null = null

  @ResponseFill()
  cidade: string | null = null

  @ResponseFill()
  sigla: string | null = null

  @ResponseFill()
  idCentroDeCusto: number | null = null

  @ResponseFill()
  idInsumo: number | null = null

  @ResponseFill()
  idTipoCriacao: number | null = null

  @ResponseFill()
  idTipoFinalizacao: number | null = null

  @ResponseFill('slaPendente')
  slaStatus: DeliverySlaStatus | null = null

  get ufResource() {
    return this.ufCollection.get(this.uf)
  }
  set ufResource(val: IResource | null) {
    this.uf = val && val.$id as UF || null
  }

  get regionResource() {
    return this.regionCollection.get(this.region)
  }
  set regionResource(val: IResource | null) {
    this.region = val && val.$id as Region || null
  }

  get centroDeCustoResource() {
    return this.allCentroDeCusto.get(this.idCentroDeCusto)
  }
  set centroDeCustoResource(val: IResource | null) {
    this.idCentroDeCusto = val && val.$id as number || null
  }

  get insumoResource() {
    return this.allTipoInsumo.get(this.idInsumo)
  }
  set insumoCustoResource(val: IResource | null) {
    this.idInsumo = val && val.$id as number || null
  }

  get tipoCriacaoResource() {
    return this.allSistema.get(this.idTipoCriacao)
  }
  set tipoCriacaoResource(val: IResource | null) {
    this.idTipoCriacao = val && val.$id as TipoSistema || null
  }

  get slaStatusResource() {
    return this.allSlaStatus.get(this.slaStatus)
  }
  set slaStatusResource(val: IResource | null) {
    this.slaStatus = val && val.$id as DeliverySlaStatus || null
  }
}
